import React, { useMemo } from 'react';
import { Text, Stack } from '@moda/om';
import AlertIcon from '@moda/icons/alert-16';
import { Order, OrderItem } from '../../../hooks/useOrder';

import './AccountOrderErrorMessage.scss';

interface Props {
  order: Order;
  orderItems: OrderItem[] | undefined;
}

export const AccountOrderErrorMessage: React.FC<Props> = ({ order, orderItems }) => {
  const items = useMemo(
    () =>
      orderItems?.filter(item =>
        order.relationships.orderItems.data.map(({ id }) => id).includes(item.id)
      ) || [],
    [order, orderItems]
  );

  const hasBillFailureError = useMemo(
    () =>
      items.some(({ attributes: { status } }) =>
        ['payment_decline_on_create', 'bill_failure'].includes(status)
      ),
    [items]
  );

  return (
    <div className="AccountOrderErrorMessage">
      {hasBillFailureError && (
        <Stack space={1} direction="horizontal">
          <AlertIcon className="AccountOrderErrorMessage__icon" />
          <Text treatment="body2" color="code-red">
            This order needs your attention. Please check the order detail page for more
            information.
          </Text>
        </Stack>
      )}
    </div>
  );
};
